import { useState } from "react";
import { Link } from "react-router-dom";
import { userApi } from "../../lib/api";
import Seo from "../../components/Seo";

const inp = "w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold";

export default function ForgotPassword() {
  const [email, setEmail] = useState(""); const [sent, setSent] = useState(false);
  const submit = async (e) => { e.preventDefault(); await userApi.post("/auth/forgot-password", { email }).catch(() => {}); setSent(true); };
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6 py-28">
      <Seo title="Şifremi Unuttum" />
      <div className="w-full max-w-md bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-10">
        <h1 className="font-serif text-3xl text-brand-green text-center mb-6">Şifremi Unuttum</h1>
        {sent ? (
          <p className="text-brand-text/70 text-center" data-testid="forgot-sent">Eğer bu e-posta kayıtlıysa, şifre sıfırlama bağlantısı gönderildi. Gelen kutunu kontrol et.</p>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form" className="space-y-4">
            <input required type="email" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} className={inp} data-testid="forgot-email" />
            <button data-testid="forgot-submit" className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-green transition-colors py-3 rounded-sm font-semibold">Sıfırlama Bağlantısı Gönder</button>
          </form>
        )}
        <p className="text-center mt-5 text-sm"><Link to="/giris" className="text-brand-gold">Girişe dön</Link></p>
      </div>
    </div>
  );
}
